module.exports = __webpack_public_path__ + "img/icon3@2x.9d58cee7.png";